import { Modal } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { TextField } from '../Base/Form'
import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { postData } from '../../../js/helpers/apiHelper'
import MilesBonusIcon from '../Base/IconComponents/MilesBonusIcon'
import Alert from '../Base/Alert'

const LoginModal = ({ open, handleClose }) => {
  const { dictionary, configuration, registerLink, milesNBonusAccount } =
    window.headerData
  const [userId, setUserId] = useState(milesNBonusAccount?.fFN || '')
  const [loading, setLoading] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])
  const [resultDescription, setResultDescription] = useState('')

  const schema = z.object({
    userId: z
      .string()
      .regex(/^1\d{8}$/, { message: dictionary.invalidMemberId }),
  })

  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    setError,
  } = useForm({
    resolver: zodResolver(schema),
    mode: 'onTouched',
    defaultValues: {
      userId,
    },
  })

  const onSubmit = (data) => {
    setLoading(true)
    if (userId) {
      postData(configuration.endpointLogout, { userId: data.userId })
        .then((res) => {
          if (res.hasError) {
            handleError(res.errorMessages)
          } else {
            window.dispatchEvent(
              new CustomEvent('loggedIn', {
                detail: {
                  isLoggedIn: false,
                },
              })
            )
            setUserId('')
            setValue('userId', '')
            setResultDescription('')
            handleClose()
            handleSuccess()
          }
        })
        .catch(() => handleError([dictionary.defaultErrorMessage]))
    } else {
      postData(configuration.endpointLogin, { userId: data.userId })
        .then((res) => {
          if (res.hasError) {
            handleError(res.errorMessages)
          } else {
            window.dispatchEvent(
              new CustomEvent('loggedIn', {
                detail: {
                  isLoggedIn: true,
                  data: res.data,
                  userId: data.userId,
                },
              })
            )
            setUserId(data.userId)
            setResultDescription(res.data.resultDescription)
            if (!res.data.resultDescription) {
              handleClose()
            }

            handleSuccess()
          }
        })
        .catch(() => handleError([dictionary.defaultErrorMessage]))
    }
  }

  const handleSuccess = () => {
    setErrorMessages([])
    setLoading(false)
  }

  const handleError = (messages) => {
    setErrorMessages(messages)
    setLoading(false)
  }

  const handleInternalClose = () => {
    if (loading) return
    setErrorMessages([])
    handleClose()
  }

  return (
    <Modal
      open={open}
      onClose={handleInternalClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      disableScrollLock={true}
      disableEscapeKeyDown={loading}>
      <form onSubmit={handleSubmit(onSubmit)} className="b-login-modal">
        <button
          type="button"
          className="btn p-0 b-login-modal__close"
          onClick={handleInternalClose}
          disabled={loading}>
          <i className="icon-x"></i>
        </button>
        <MilesBonusIcon width={207} height={26} />
        <div>
          <TextField
            label="Miles+Bonus member ID"
            name="userId"
            control={control}
            error={errors.userId}
            disabled={userId}
          />
          {errorMessages.length > 0 && (
            <div className="mt-10">
              <Alert messages={errorMessages} />
            </div>
          )}
          {resultDescription && (
            <div className="mt-10">
              <Alert
                messages={[resultDescription]}
                type="warning"
                alternativeWarning
              />
            </div>
          )}
        </div>
        <button
          type="submit"
          className="btn btn-primary btn-full-width"
          disabled={loading}>
          {userId ? dictionary.logoutBtn : dictionary.loginBtn}
        </button>
        {!userId && (
          <div className="b-login-modal__footer">
            <span>{dictionary.notMember}</span>
            <a
              href={registerLink.url}
              className="btn btn-link b-login-modal__register">
              {registerLink.text}
            </a>
          </div>
        )}
      </form>
    </Modal>
  )
}

export default LoginModal
